import React, { useState, useEffect } from "react";
import api from "../api";

const Cars = ({ refresh }) => {
  const [cars, setCars] = useState([]);
  const [selectedCars, setSelectedCars] = useState({});
  const [formValues, setFormValues] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCars();
  }, [refresh]);

  const fetchCars = async () => {
    setLoading(true);
    try {
      const response = await api.get("/cars");
      setCars(response.data);
    } catch (error) {
      console.error("Failed to fetch cars", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectCar = (carId) => {
    setSelectedCars((prev) => ({
      ...prev,
      [carId]: !prev[carId],
    }));
  };

  const handleInputChange = (carId, field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [carId]: {
        ...prev[carId],
        [field]: value,
      },
    }));
  };

  const handleBulkUpdate = async () => {
    setLoading(true);
    try {
      const updates = Object.keys(formValues).map((key) => ({
        id: key,
        data: formValues[key],
      }));

      await api.put("/cars/bulk-update", updates);

      setSelectedCars({});
      setFormValues({});
      refresh();
    } catch (error) {
      console.error("Failed to update cars", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-semibold mb-6 text-center">
        Update Multiple Cars
      </h2>

      {loading ? (
        <div className="flex flex-col justify-center items-center py-16">
          {/* ДВОЙНОЙ СПИНЕР */}
          <div className="relative w-16 h-16">
            <div className="absolute inset-0 border-4 border-indigo-200 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-transparent border-t-indigo-600 rounded-full animate-spin"></div>
          </div>

          <p className="mt-4 text-sm text-gray-500">
            Обновляем данные машин...
          </p>
        </div>
      ) : (
        <>
          <button
            onClick={handleBulkUpdate}
            disabled={loading || !Object.keys(selectedCars).length}
            className={`mb-6 px-4 py-2 rounded-lg transition duration-300 text-white
              ${
                loading || !Object.keys(selectedCars).length
                  ? "bg-indigo-300 cursor-not-allowed"
                  : "bg-indigo-600 hover:bg-indigo-700"
              }`}
          >
            Update Selected
          </button>

          <ul className="space-y-4">
            {cars.map((car) => (
              <li
                key={car._id}
                className="flex flex-col p-4 bg-gray-50 rounded-lg shadow-sm hover:bg-gray-100 transition duration-300"
              >
                <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={!!selectedCars[car._id]}
                    onChange={() => handleSelectCar(car._id)}
                    className="w-5 h-5 text-indigo-600"
                  />
                  <span className="text-lg font-medium">
                    {car.make} {car.model} — {car.owner}
                  </span>
                </div>

                {selectedCars[car._id] && (
                  <div className="mt-4 space-y-2">
                    {[
                      ["make", "Make"],
                      ["model", "Model"],
                      ["owner", "Owner"],
                      ["color", "Color"],
                      ["registration_number", "Registration number"],
                      ["address", "Address"],
                    ].map(([field, label]) => (
                      <input
                        key={field}
                        type="text"
                        placeholder={label}
                        value={formValues[car._id]?.[field] ?? car[field]}
                        onChange={(e) =>
                          handleInputChange(car._id, field, e.target.value)
                        }
                        className="w-full p-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
                      />
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default Cars;
